import { render, staticRenderFns } from "./SectionInput.vue?vue&type=template&id=90c31b52&"
import script from "./SectionInput.vue?vue&type=script&lang=js&"
export * from "./SectionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports